import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IRequestor } from 'src/app/shared/models/requestor/IRequestor';
import { ApiResponseSimple } from 'src/app/shared/models/api-response-simple/ApiResponseSimple';
import { catchError, switchMap, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { EnvironmentResolveService } from '../environment-resolve/environment-resolve.service';

@Injectable({
  providedIn: 'root'
})
export class RequestAccessService {
  constructor(
    private http: HttpClient,
    private erService: EnvironmentResolveService) {}

  public requestAccess(requestor: IRequestor): Observable<any> {
    return this.http.post(this.erService.environmentERS.apiUrlRequestAccess, requestor).pipe(
      map((response: ApiResponseSimple) => {
        return response;
      }),
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
}
